import { useState, useCallback, useEffect } from 'react';
import { useFormik } from 'formik';

import { createOrUpdateArea, getAreaByAreaId } from 'api/area';
import AreaDomain from 'domain/master/sales/area';
import useToastNotification from 'hooks/useToastNotification';
import { useHistory } from 'react-router-dom';


type AreaDomainKey = keyof Pick<AreaDomain, 'areaCode'|'areaName'>;

export const useAreaAddForm = (areaId?: string) => {
  let isEdit = false;
  if (areaId) {
    isEdit = true;
  } else {
    isEdit = false;
  }

  const [detailMode, setDetailMode] = useState(false);

  const [confirmModalOpen, setConfirmModalOpen] = useState(false);

  // modal confirm
  const [toastModalOpen, setToastModalOpen] = useState(false);

  // Modal alert
  const { successNotification, errorNotification } = useToastNotification();
  const history = useHistory();
  const onSubmit = async (values: AreaDomain) => {
    if (values.areaCode === null) {
      errorNotification('エリアコードを入力してください。');
      return;
    }
    if (values.areaName === null) {
      errorNotification('エリア名を入力してください。');
      return;
    }
    if ((/^ *$/.test(values.areaCode) || /^ *$/.test(values.areaName)) && (values.areaName !== '' && values.areaCode !== '')) {
      setConfirmModalOpen(false);
      errorNotification('コードに半角、全角スペースは入力できません。');
      return;
    }

    if (!confirmModalOpen) {
      setConfirmModalOpen(true);
      return;
    }
    try {
      const companyCode = sessionStorage.getItem('loginUser.companyCode') || '';
      const response = await createOrUpdateArea(
        companyCode, false, values.getRawData(), isEdit,
      );
      if (!response.errors) {
        successNotification(isEdit ? '更新しました。' : '登録しました。');
        history.push('/areas');
      }
    } catch (error) {
      setConfirmModalOpen(false);
      if (error.response && error.response.data && error.response.data.errors) {
        const listErr = error.response.data.errors;
        let stringErr = '';
        listErr.map((element: any) => {
          stringErr += `${element.defaultMessage} \n`;
          return stringErr;
        });
        errorNotification(stringErr);
      } else {
        errorNotification('サーバー側でエラーが発生しました。');
        throw error;
      }
    }
  };

  const formik = useFormik({
    initialValues: AreaDomain.generateInitial(),
    validationSchema: false,
    onSubmit,
  });

  useEffect(() => {
    if (areaId) {
      getAreaByAreaId(areaId).then((response: any) => {
        if (response) {
          formik.setValues(new AreaDomain(response));
        }
      });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [areaId]);


  const closeConfirmModal = useCallback(() => {
    setConfirmModalOpen(false);
  }, []);

  return {
    formik,
    detailMode,
    setDetailMode,
    confirmModalOpen,
    closeConfirmModal,
    toastModalOpen,
    setToastModalOpen,
  };
};

export default {
  useAreaAddForm,
};
